export default function Button({
    children,
    ...rest
}: React.PropsWithChildren<React.HtmlHTMLAttributes<HTMLButtonElement>>) {
    return <button {...rest}>{children}</button>
}
